import React from 'react';
import { createBrowserRouter } from 'react-router-dom';

import * as Sentry from '@sentry/react';

import { App } from '@components/App';
import { Root } from '@components/Root';

const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(
    createBrowserRouter,
);

export const router = sentryCreateBrowserRouter([
    {
        path: '*',
        element: (
            <Root>
                <App />
            </Root>
        ),
    },
]);
